import React from 'react';

export default function HomeSearchPanel({
  homeSearchTerm,
  setHomeSearchTerm,
  searchLoading,
  searchResults,
  onOpenTrial,
}) {
  return (
    <div className="rounded-xl border border-slate-700 bg-slate-800/70 p-3">
      <div className="text-xs uppercase tracking-wide text-slate-400 mb-2">Search Trials</div>
      <input
        value={homeSearchTerm}
        onChange={(e) => setHomeSearchTerm(e.target.value)}
        placeholder="Search by title..."
        className="w-full rounded-lg bg-slate-900 border border-slate-700 text-slate-100 px-3 py-2 text-sm outline-none focus:ring-2 focus:ring-purple-500/40"
      />
      {homeSearchTerm.trim() && (
        <div className="mt-2 text-xs text-slate-400">
          {searchLoading ? 'Searching...' : `${searchResults.length} result${searchResults.length === 1 ? '' : 's'}`}
        </div>
      )}
      {homeSearchTerm.trim() && !searchLoading && (
        <div className="mt-3 space-y-2">
          {searchResults.length === 0 ? (
            <div className="text-xs text-slate-500">No matching live trials.</div>
          ) : searchResults.map((row) => (
            <button
              key={row.id}
              onClick={() => onOpenTrial?.(row)}
              className="w-full text-left rounded-lg border border-slate-700 bg-slate-900/60 hover:bg-slate-900 px-3 py-2"
            >
              <div className="text-sm font-semibold text-slate-100 truncate">{row.title || 'Untitled trial'}</div>
              <div className="text-xs text-slate-400">{row.side_a || 'A'} vs {row.side_b || 'B'}</div>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
